import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import colors from '../styles/colors';
import { useTranslation } from 'react-i18next';
import { getMenuData } from '../data/menuData';
import { useMultiLanguage } from '../hooks/useMultiLanguage';
import logo from '../assets/images/logo.png';

const PrintStyles = createGlobalStyle`
  @page { size: A4; margin: 12mm; }
  @media print {
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .no-print { display: none !important; }
    .page-break { page-break-after: always; }
    section { border: none !important; }
  }
`;

const Wrapper = styled.div`
  max-width: 930px;
  margin: 0 auto;
  color: ${colors.text.primary};
  font-family: Arial, Helvetica, sans-serif;
`;

const HeaderBar = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 16px 0;
  padding: 12px 0;
  border-bottom: 4px solid ${colors.primary.green};
`;

const Title = styled.h1`
  font-size: 28px;
  margin: 0;
`;

const Logo = styled.img`
  height: 48px;
`;

const PrintBtn = styled.button`
  padding: 8px 12px;
  border: 2px solid ${colors.primary.green};
  background: #fff;
  color: ${colors.primary.green};
  border-radius: 6px;
  cursor: pointer;
  &.no-print {}
`;

const Section = styled.section`
  background: #fff;
  border: 2px solid ${colors.primary.green}20;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 14px;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 10px;
  h2 { color: ${colors.primary.green}; margin: 0 0 4px 0; }
  p { color: ${colors.text.secondary}; margin: 0; font-size: 12px; }
`;

const ItemRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px dashed #e3e3e3;
`;

const ItemName = styled.div`
  font-weight: 700;
`;

const ItemDesc = styled.div`
  color: ${colors.text.secondary};
  font-size: 12px;
`;

const ItemDescSecondary = styled.div`
  color: ${colors.text.secondary}B3;
  font-size: 10px;
  font-style: italic;
`;

const ItemPrice = styled.div`
  font-weight: 800;
  white-space: nowrap;
`;

const RenderBlock = ({ t, getTranslations, keyName }) => {
  const block = getMenuData(keyName);
  if (!block) return null;
  return (
    <Section>
      <SectionHeader>
        <h2>{t(`menu.${keyName}`, { defaultValue: block.title })}</h2>
        <p>{t(`menu.${keyName}Subtitle`, { defaultValue: block.subtitle || '' })}</p>
      </SectionHeader>
      {block.items.map((it) => {
        const name = getTranslations(it.id, 'name');
        const desc = getTranslations(it.id, 'description');
        return (
          <ItemRow key={`${keyName}-${it.id}`}>
            <div>
              <ItemName>{name.mainText || it.name}</ItemName>
              {(desc.mainText || it.description) && (
                <ItemDesc>{desc.mainText || it.description}</ItemDesc>
              )}
              {desc.secondaryTexts.map((s, idx) => (
                <ItemDescSecondary key={idx}>{s.text}</ItemDescSecondary>
              ))}
            </div>
            <ItemPrice>{it.price}</ItemPrice>
          </ItemRow>
        );
      })}
    </Section>
  );
};

const PrintableAppetizerMenu = () => {
  const { t } = useTranslation();
  const { getTranslations } = useMultiLanguage();

  return (
    <Wrapper>
      <PrintStyles />
      <HeaderBar>
        <Logo src={logo} alt="Cuore Brasiliano" />
        <Title>{t('menu.appetizerMenuTitle')}</Title>
        <PrintBtn className="no-print" onClick={() => window.print()}>{t('menu.print', { defaultValue: 'Imprimir' })}</PrintBtn>
      </HeaderBar>

      <RenderBlock t={t} getTranslations={getTranslations} keyName="petiscos" />
      <RenderBlock t={t} getTranslations={getTranslations} keyName="cervejas" />
      <RenderBlock t={t} getTranslations={getTranslations} keyName="bebidas" />
      <RenderBlock t={t} getTranslations={getTranslations} keyName="drinks" />
    </Wrapper>
  );
};

export default PrintableAppetizerMenu;


